<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                {{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    export default {
        data() {
            return {
                collapse: false,
                items: []
            }
        },
        computed:{
            onRoutes(){
                return this.$route.path.replace('/','');
            }
        },
        created(){
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })
            let group = localStorage.getItem("Group");
            // alert(group);
            if (group == "overseamanager.perm_level_high") {
                this.items = [
                    {
                        icon: 'el-icon-s-home',
                        index: 'dashboard',
                        title: 'Home'
                    },
                    {
                        icon: 'el-icon-s-management',
                        index: 'InformationManage',
                        title: 'Information Manage',
                        subs: [
                            {
                                index: 'CountryInfo',
                                title: 'National Information',
                            },
                            {
                                index: 'FlashToolInfo',
                                title: 'FlashTool Information',
                            },
                            {
                                index: 'ProjectInfo',
                                title: 'Project Information',
                            },
                            {
                                index: 'NoDeliveryRecordFromLocalTester',
                                title: 'FT Information',
                            },
                            {
                                index: 'NoRecordOfLocalTester',
                                title: 'Special Delivery Record',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-orange',
                        index: 'Arrangement_work',
                        title: 'Arrangement(Work)',
                        subs: [
                            {
                                index: 'TaskArrangement',
                                title: 'Task Arrangement',
                            },
                            {
                                index: 'WorkArrangement',
                                title: 'Work Arrangement&Test',
                            },
                            {
                                index: 'WorkArrangementAll',
                                title: 'Task Archive',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-bangzhu',
                        index: 'Arrangement_sample',
                        title: 'Arrangement(Sample)',
                        subs: [
                            {
                                index: 'SampleInformation',
                                title: 'Sample Express',
                            },
                            {
                                index: 'SampleInformationReceiver',
                                title: 'Sample  Receive',
                            },
                            {
                                index: 'SampleInformationAll',
                                title: 'Sample Information All',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-key',
                        index: 'AccountManagement',
                        title: 'Account Management'
                    }
                ]
            } else if(group == "overseamanager.perm_level_middle") {
                this.items = [
                    {
                        icon: 'el-icon-s-home',
                        index: 'dashboard',
                        title: 'Home'
                    },
                    {
                        icon: 'el-icon-s-management',
                        index: 'InformationManage',
                        title: 'Information Manage',
                        subs: [
                            {
                                index: 'CountryInfo',
                                title: 'National Information',
                            },
                            {
                                index: 'FlashToolInfo',
                                title: 'FlashTool Information',
                            },
                            {
                                index: 'ProjectInfo',
                                title: 'Project Information',
                            },
                            {
                                index: 'NoDeliveryRecordFromLocalTester',
                                title: 'FT Information',
                            },
                            {
                                index: 'NoRecordOfLocalTester',
                                title: 'Special Delivery Record',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-orange',
                        index: 'Arrangement_work',
                        title: 'Arrangement(Work)',
                        subs: [
                            {
                                index: 'TaskArrangement',
                                title: 'Task Arrangement',
                            },
                            {
                                index: 'WorkArrangement',
                                title: 'Work Arrangement&Test',
                            },
                            {
                                index: 'WorkArrangementAll',
                                title: 'Task Archive',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-bangzhu',
                        index: 'Arrangement_sample',
                        title: 'Arrangement(Sample)',
                        subs: [
                            {
                                index: 'SampleInformation',
                                title: 'Sample Express',
                            },
                            {
                                index: 'SampleInformationReceiver',
                                title: 'Sample  Receive',
                            },
                            {
                                index: 'SampleInformationAll',
                                title: 'Sample Information All',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-key',
                        index: 'AccountManagement',
                        title: 'Account Management'
                    }
                ]
            } else if(group == "overseamanager.perm_level_low") {
                this.items = [
                    {
                        icon: 'el-icon-s-home',
                        index: 'dashboard',
                        title: 'Home'
                    },
                    {
                        icon: 'el-icon-s-management',
                        index: 'InformationManage',
                        title: 'Information Manage',
                        subs: [
                            {
                                index: 'CountryInfo',
                                title: 'National Information',
                            },
                            {
                                index: 'FlashToolInfo',
                                title: 'FlashTool Information',
                            },
                            {
                                index: 'ProjectInfo',
                                title: 'Project Information',
                            },
                            {
                                index: 'NoDeliveryRecordFromLocalTester',
                                title: 'FT Information',
                            },
                            {
                                index: 'NoRecordOfLocalTester',
                                title: 'Special Delivery Record',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-orange',
                        index: 'Arrangement_work',
                        title: 'Arrangement(Work)',
                        subs: [
                            {
                                index: 'WorkArrangement',
                                title: 'Work Arrangement&Test',
                            },
                            {
                                index: 'WorkArrangementAll',
                                title: 'Task Archive',
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-bangzhu',
                        index: 'Arrangement_sample',
                        title: 'Arrangement(Sample)',
                        subs: [
                            {
                                index: 'SampleInformation',
                                title: 'Sample Express',
                            },
                            {
                                index: 'SampleInformationReceiver',
                                title: 'Sample  Receive',
                            },
                            {
                                index: 'SampleInformationAll',
                                title: 'Sample Information All',
                            }
                        ]
                    }
                ]
            } else if(group == "overseamanager.perm_level_lowest") {
                this.items = [
                    {
                        icon: 'el-icon-s-home',
                        index: 'dashboard',
                        title: 'Home'
                    },
                    {
                        icon: 'el-icon-bangzhu',
                        index: 'Arrangement_sample',
                        title: 'Arrangement(Sample)',
                        subs: [
                            {
                                index: 'SampleInformation',
                                title: 'Sample Express',
                            },
                            {
                                index: 'SampleInformationReceiver',
                                title: 'Sample  Receive',
                            },
                            {
                                index: 'SampleInformationAll',
                                title: 'Sample Information All',
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .sidebar{
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom:0px;
        overflow-y: scroll;
    }
    .sidebar::-webkit-scrollbar{
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse){
        width: 250px;
    }
    .sidebar > ul {
        height:100%;
    }
</style>
